<template>
    <modal v-bind:show.sync="show" ref="modal">
        <div slot="header">
            <nav class="nav nav-tab br-bottom">
                <a class="nav-item nav-item--active f-s-4 m-r-3">{{ trans('Upload Videos') }}</a>
            </nav>
        </div>
        <div class="form-group">
            <div class="uploads-group">
                <div class="card column uploads uploads-r-1_3 br c-lightest-bg text-center p-l-4 p-r-4">
                    <div class="upload-content row row-middle full-width-dropzone">
                        <div class="upload-content row row-middle row-collapse">
                            <div
                                style="cursor: pointer; width: 100%; height: 100%;"
                                v-on:drop="handleFileSelect"
                                v-on:dragover="handleDragOver"
                                v-on:click="handleDropzoneClick"
                            >
                                <div class="row row-middle row-tall">
                                    <div class="column text-center">
                                        <div class="card-figure m-b-4 p-l-4 p-r-4">
                                            <span class="i-container i-tone-accent">
                                                <!-- /icons/xlg-drag-video.svg -->
                                                <svg class="icon i-size-xlarge" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><g fill="#6F6FFF" class="icon"><path d="M24.905 36.891a.995.995 0 0 0 .974.041l15.43-7.77a1 1 0 0 0 0-1.786l-15.43-7.77a1.002 1.002 0 0 0-1.451.894v15.54c.002.347.181.669.477.851zm1.525-14.768l12.206 6.147-12.206 6.147V22.123z"/><path d="M54.359 12H8.5a1 1 0 0 0-1 1v32a1 1 0 0 0 1 1h45.859a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zm-1 32H9.5V14h43.859v30zM54 48.5H24a1 1 0 1 0 0 2h30a1 1 0 1 0 0-2z"/><circle cx="9.25" cy="49.75" r="1.25"/><circle cx="13.999" cy="49.75" r="1.25"/><circle cx="18.499" cy="49.75" r="1.25"/></g><path fill="#CCE6FF" class="icon-2" d="M63 64h-2a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm-5.867 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.734 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.733 0H37.8a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.733 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.734 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.733 0H14.6a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.734 0H6.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zM3 64H1a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2zm-2-5.867a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zM1 50.4a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0V49.4a1 1 0 0 1-1 1zm0-7.733a1 1 0 0 1-1-1V37.8a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zm0-7.734a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zM1 27.2a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0V26.2a1 1 0 0 1-1 1zm0-7.734a1 1 0 0 1-1-1V14.6a1 1 0 1 1 2 0v3.867a.999.999 0 0 1-1 .999zm0-7.733a1 1 0 0 1-1-1V6.866a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zM1 4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v1a1 1 0 0 1-1 1zm56.134-2h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zM49.4 2h-3.866a1 1 0 1 1 0-2H49.4a1 1 0 1 1 0 2zm-7.733 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.733 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zM26.2 2h-3.866a1 1 0 1 1 0-2H26.2a1 1 0 1 1 0 2zm-7.733 0h-3.866a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zm-7.734 0H6.867a1 1 0 1 1 0-2h3.866a1 1 0 1 1 0 2zM63 4a1 1 0 0 1-1-1V2h-1a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0 54.133a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zm0-7.733a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0V49.4a1 1 0 0 1-1 1zm0-7.733a1 1 0 0 1-1-1V37.8a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zm0-7.734a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1zm0-7.733a1 1 0 0 1-1-1v-3.867a1 1 0 1 1 2 0V26.2a1 1 0 0 1-1 1zm0-7.734a1 1 0 0 1-1-1V14.6a1 1 0 1 1 2 0v3.867a.999.999 0 0 1-1 .999zm0-7.733a1 1 0 0 1-1-1V6.866a1 1 0 1 1 2 0v3.867a1 1 0 0 1-1 1z"/></svg>
                                            </span>
                                        </div>
                                        <div class="card-content">
                                            <h2 class="card-title f-s-5 f-w-bold m-b-1 f-w-regular">{{ trans('Drag & Drop') }}</h2>
                                            <p class="f-s-4 c-muted">{{ trans('or browse your computer for a file') }}</p>
                                        </div>
                                        <input id="browse" type="file" style="display: none;" v-on:change="handleFileSelect" ref="browse" multiple="multiple">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-t-5">
                    <div v-bind:class="{'has-error': errors.has('module_id')}" class="form-group form-group-compact">
                        <label for="module_id">{{ trans('Select module for imported videos') }}</label>
                        <select class="input__field" ref="module_id" name="module_id" id="module_id" v-model="moduleId">
                            <option v-bind:value="null">{{ trans('Select module') }}</option>
                            <option disabled>---</option>
                            <option value="NEW">{{ trans('Create new module') }}</option>
                            <option v-if="moduleItems.length > 0" disabled>---</option>
                            <option v-for="module in moduleItems" v-bind:key="module.encoded_id" v-bind:value="module.encoded_id">{{ module.name }}</option>
                        </select>
                    </div>
                    <div v-if="errors.has('module_id')" class="form-help">{{ errors.get('module_id') }}</div>
                    <div v-if="moduleId && moduleId === 'NEW'" v-bind:class="{'has-error': errors.has('module_name')}" class="form-group">
                        <input v-model="moduleName" class="input__field" type="text" ref="module_name" name="module_name" v-bind:placeholder="trans('Module name')" maxlength="255" required>
                    </div>
                    <div v-if="errors.has('module_name')" class="form-help">{{ errors.get('module_name') }}</div>
                </div>
                <div class="slat m-t-2 m-b-2 row row-middle row-collapse br-bottom" v-for="(video, index) in items" v-bind:key="index">
                    <div class="column">
                        <div class="row row-collapse-indent row-middle p-b-2 p-t-2">
                            <div class="slat-content column">
                                <h4 v-if=" ! video.error" class="f-w-bold f-s-3 m-b-0">{{ video.uploadFileName }}</h4>
                                <p v-if=" ! video.uploaded && ! video.error" class="f-s-3 m-0 c-medium-tint">{{ video.uploadMbSent }}MB {{ trans('of') }} {{ video.uploadMbTotal }}MB</p>
                                <p v-if="video.uploaded" class="f-s-3 m-0 c-medium-tint">
                                    <!-- /icons/check.svg -->
                                    <svg class="icon m-b-1 i-size-small m-r-1" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="#24D7C5"><path d="M19 4H5c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-1 2v9h-3c-.6 0-1 .4-1 1v1h-4v-1c0-.6-.4-1-1-1H6V6h12z"/><path d="M10.3 13.7c.5.5 1 .4 1.4 0l4-4c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L11 11.6l-1.3-1.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2z"/></g></svg>
                                    {{ trans('Uploaded') }}
                                </p>
                                <h4 v-if="video.error" class="f-w-bold f-s-3 m-b-0 c-error">{{ trans('Oops! Upload failed') }}</h4>
                                <p v-if="video.error" class="f-s-3 m-0 c-medium-tint">
                                    {{ video.error }}
                                    <a v-on:click.prevent="removeFile(index)" class="ul" href="#remove-video">{{ trans('Try Again.') }}</a>
                                </p>
                            </div>
                            <div class="slat-aside text-right m-r-4">
                                <div v-if=" ! video.uploaded && ! video.error" class="fl-left m-r-2">
                                    <upload-progress-donut
                                        v-if="video.uploading"
                                        size="small"
                                        v-bind:percentage="video.uploadProgress"
                                    ></upload-progress-donut>
                                    <div v-if="video.processing" class="chartdonut chartdonut_animation--rotate chartdonut--small">
                                        <svg width="33" height="33"><g><circle cx="50%" cy="50%" r="13" stroke-width="3" stroke="#02DCAA" fill="none" stroke-dashoffset="5"></circle></g></svg>
                                    </div>
                                </div>
                                <a class="i-container i-filled-dark cu-p" href="#remove-video" v-on:click.prevent="removeFile(index)">
                                    <!-- /icons/remove.svg -->
                                    <svg class="icon icon-remove i-size-medium" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#FFF" cx="16" cy="16" r="16"/><path fill="#AAB2BD" fill-rule="nonzero" d="M23 10.41L21.59 9 16 14.59 10.41 9 9 10.41 14.59 16 9 21.59 10.41 23 16 17.41 21.59 23 23 21.59 17.41 16z"/></g></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="row row-collapse">
                <div class="column">
                    <button type="button" class="btn btn-primary" v-on:click="addVideos" v-bind:class="{'btn-loading': saving, 'btn-disabled': importDisabled}" v-bind:disabled="importDisabled">
                        {{ trans('Import Videos') }}
                        <div class="loader" v-if="saving">
                            <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                                <svg class="i-stroke-bright" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import Errors from '../../errors.js';
import { EventBus } from '../../event-bus.js';
import { BunnyUploader, VimeoUploader } from '../../uploader';
import Modal from './Modal.vue';

export default {
    components: {
        Modal
    },
    props: {
        hubId: {
            type: String
        },
        videoHostingProvider: {
            type: String,
            default: 'bunny'
        },
        modules: {
            type: [Array, Object],
        },
    },
    data() {
        return {
            show: false,
            saving: false,
            items: [],
            moduleItems: this.modules,
            moduleId: null,
            moduleName: null,
            errors: new Errors(),
        }
    },
    computed: {
        importDisabled() {
            // Disable import button if there are no files uploaded
            if (this.items.length === 0) {
                return true;
            }

            // Check if there is any file that is being uploaded
            for (let item of this.items) {
                if (item.uploading) {
                    return true;
                }
            }

            // Check if all files have errors
            for (let item of this.items) {
                if ( ! item.error) {
                    return false;
                }
            }

            return true;
        }
    },
    methods: {
        addVideos() {
            this.errors.clear();

            if (this.moduleId === null) {
                this.$refs.module_id.focus();
                this.errors.record({
                    'module_id': [this.trans('Please select a module')],
                });

                return;
            } else if (this.moduleId === 'NEW' && (this.moduleName === null || this.moduleName === '')) {
                this.$refs.module_name.focus();
                this.errors.record({
                    'module_id': [this.trans('Please enter a module name')],
                });

                return;
            }

            this.saving = true;

            window.axios.post(Kourses.apiBaseUrl + '/lessons/' + this.hubId + '/bulk-import', {
                'module_id': this.moduleId,
                'module_name': this.moduleName,
                'lessons': this.items.filter((video) => video.error === false).map((video) => {
                    return {
                        name: video.uploadFileName,
                        video: video.fileUrl,
                        video_type: this.videoHostingProvider,
                        length: video.duration,
                        video_size: video.uploadMbTotal,
                    };
                }),
            }).then((response) => {
                let moduleWithLessons = response.data;

                EventBus.$emit('lessons:added', moduleWithLessons);

                this.close();
            });
        },
        close() {
            this.show = false;
            this.items = [];
            this.saving = false;
        },
        removeFile(index) {
            // In case that file type was unsupported there will be no "uploader"
            if (this.items[index].uploader) {
                this.items[index].uploader.terminate();
            }
            this.items.splice(index, 1);
        },
        getFile(fileName) {
            return this.items.find((item) => {
                return item.uploadFileName === fileName;
            });
        },
        handleFileSelect(event) {
            event.stopPropagation();
            event.preventDefault();

            let $vm = this;
            let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;

            for (let file of files) {
                // Check file type
                if (0 > file.type.indexOf('video/')) {
                    $vm.items.push({
                        uploading: false,
                        processing: false,
                        safeToSave: false,
                        error: $vm.trans('Unsupported file format'),
                    });

                    continue;
                }

                const uploader = this.createVideoUploader();
                uploader.upload(file, {
                    onError: (error) => {
                        let item = $vm.getFile(file.name);
                        item.error = error;
                        item.uploading = false;
                        item.processing = false;
                    },
                    onProgress: (bytesUploaded, bytesTotal) => {
                        let item = $vm.getFile(file.name);
                        item.uploadMbSent = (bytesUploaded / 1024 / 1024).toFixed(2);
                        item.uploadProgress = parseInt((bytesUploaded / bytesTotal) * 100);
                    },
                    onSuccess: (fileUrl) => {
                        let item = $vm.getFile(file.name);
                        item.fileUrl = fileUrl;
                        item.uploading = false;
                        item.processing = true;
                    },
                    onTranscoded: ({thumbnail, length}) => {
                        let item = $vm.getFile(file.name);
                        item.duration = length;
                        item.uploading = false;
                        item.processing = false;
                    },
                });

                $vm.items.push({
                    uploading: true,
                    processing: false,
                    safeToSave: false,
                    uploadProgress: 0,
                    uploadFileName: file.name,
                    uploadMbSent: 0,
                    uploadMbTotal: (file.size / 1024 / 1024).toFixed(2),
                    error: false,
                    metadata: null,
                    total: file.size,
                    uploaded: false,
                    fileUrl: null,
                    uploader: uploader,
                    duration: null,
                });
            }
        },
        handleDragOver(event) {
            event.stopPropagation();
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
        },
        handleDropzoneClick() {
            this.$refs['browse'].click();
        },
        createVideoUploader() {
            if (this.videoHostingProvider === 'vimeo') {
                return new VimeoUploader({
                    vimeoToken: window.Vimeo.token,
                    vimeoApiUrl: window.Vimeo.apiBaseUrl,
                    vimeoFolder: window.Vimeo.folder,
                    koursesApiUrl: window.Kourses.apiBaseUrl,
                    koursesDomains: [
                        window.Kourses.baseUrl,
                        window.Kourses.websiteUrl,
                    ],
                    koursesWebsiteId: window.Kourses.websiteId,
                });
            } else if (this.videoHostingProvider === 'bunny') {
                return new BunnyUploader({
                    bunnyApiKey: window.Bunny.apiKey,
                    bunnyApiUrl: window.Bunny.apiBaseUrl,
                    bunnyLibraryId: window.Bunny.libraryId,
                    bunnyPullZoneUrl: window.Bunny.pullZoneUrl,
                    bunnyCollectionId: window.Bunny.collection,
                    koursesApiUrl: window.Kourses.apiBaseUrl,
                    koursesWebsiteId: window.Kourses.websiteId,
                });
            }
        }
    },
    created() {
        let $vm = this;

        EventBus.$on('modal:bulk-video-upload', () => {
            $vm.show = true;
            $vm.loading = false;
        });

        $vm.$on('close', () => {
            $vm.close();
        })

        // Listen for new modules added so we can show them for next bulk upload
        EventBus.$on('lessons:added', (moduleWithLessons) => {
            if ($vm.moduleItems.length > 0 && $vm.moduleItems.find(module => module.id === moduleWithLessons.id)) {
                return;
            }

            $vm.moduleItems.push(moduleWithLessons);
        });
    },
}
</script>